import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/bthinking/bthinking/src/components/mdx/MDXPageLayout";
import { withPrefix } from 'gatsby';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "sobre-o-bridge",
      "style": {
        "position": "relative"
      }
    }}>{`Sobre o Bridge`}</h1>
    <p>{`O Bridge é um laboratório integrado ao Centro Tecnológico (CTC) da Universidade Federal de Santa Catarina (UFSC), que atua na pesquisa e desenvolvimento de soluções tecnológicas conectando governo e cidadãos por meio da inovação.`}</p>
    <h2 {...{
      "id": "img-srcwithprefiximageteamjpg--altbridge-team-",
      "style": {
        "position": "relative"
      }
    }}><img src={withPrefix("/image/team.jpg")} alt="Bridge Team" /></h2>
    <h2 {...{
      "id": "o-que-valorizamos",
      "style": {
        "position": "relative"
      }
    }}>{`O que valorizamos`}</h2>
    <p>{`Como organização e indivíduos, respeitamos a sociedade, assim como colaboradores, parceiros, comunidade acadêmica, clientes e todos aqueles que impactamos. Trabalhamos para alcançar resultados com simplicidade, não deixando de lado a constante busca pela criatividade e inovação tecnológica. Nosso compromisso é contribuir positivamente com a sociedade, dando sempre valor à ética e transparência em nossos projetos. Temos acima de tudo paixão e compromisso com as pessoas e a tecnologia. Com humildade, assumimos desafios encorajando toda a equipe a trabalhar de forma unida, para atingir a mais alta qualidade, agilidade e excelência.`}</p>
    <h2 {...{
      "id": "nosso-trabalho",
      "style": {
        "position": "relative"
      }
    }}>{`Nosso trabalho`}</h2>
    <p>{`Para conhecer mais sobre o nosso trabalho, acesse o site do  `}<a href="https://bridge.ufsc.br/">{`Laboratório Bridge`}</a>{`.`}</p>
    <p>{`Ainda não conhece o design system open source do Bridge? Acesse o `}<a href="https://bold.bridge.ufsc.br/pt/">{` Bold. `}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      